import {
    EU_VAT_PATTERNS,
    EUCountryCode,
    IVATValidationResult
} from "niteroi/packages/system/models/interfaces";

export default class Validation {
    public static isValidEmail(email: string): boolean {
        return /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*$/i.test(email);
    }

    public static validateEUVatFormat(
        input: string
    ): IVATValidationResult {
        // Strip whitespace, dots, dashes and convert to uppercase
        const sanitized = input.replace(/[\s.\-/]/g, "").toUpperCase();

        if (!sanitized) {
            return { isValid: false, error: 'VAT number is empty.' };
        }

        // Extract first 2 characters as country code
        let countryCode = sanitized.slice(0, 2);
        const vatDigits = sanitized.slice(2);

        // Greece accepts 'GR' in international usage, but VIES uses 'EL'
        if (countryCode === 'GR') {
            countryCode = 'EL';
        }

        if (!(countryCode in EU_VAT_PATTERNS)) {
            return {
                isValid: false,
                error: `Unsupported or non-EU country code: ${countryCode}`,
            };
        }

        const validCountry = countryCode as EUCountryCode;
        const pattern = EU_VAT_PATTERNS[validCountry];
        const isValid = pattern.test(vatDigits);

        return {
            isValid,
            countryCode: validCountry,
            cleanVatNumber: vatDigits,
            error: isValid ? undefined : `Invalid VAT format for country ${validCountry}.`,
        };
    }
}
